import {
  CREATE_WISH_LIST_FAIL,
  CREATE_WISH_LIST_SUCCESS,
  CustomWishListActions,
  LOAD_WISH_LIST_FAIL,
  LOAD_WISH_LIST_SUCCESS, REMOVE_WISH_LIST_FAIL, REMOVE_WISH_LIST_SUCCESS
} from '../actions/wish-list.action';
import {ActionReducerMap} from '@ngrx/store';
import {InjectionToken, Provider} from '@angular/core';
import {CustomWishlistState} from '../wishlist-state';
import {Wishlist} from '../../wishlist.model';

export const initialState: any = null;


export function WishListReducer(
  state = initialState,
  action: CustomWishListActions,
): Wishlist {
  switch (action.type) {
    case LOAD_WISH_LIST_FAIL: {
      return initialState;
    }
    case LOAD_WISH_LIST_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
    case CREATE_WISH_LIST_FAIL: {
      return initialState;
    }
    case CREATE_WISH_LIST_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
    case
    REMOVE_WISH_LIST_FAIL: {
      return initialState;
    }
    case
    REMOVE_WISH_LIST_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
  }
  return state;
}

export function getWishlistReducers(): ActionReducerMap<CustomWishlistState> {
  return {
    wishList: WishListReducer
  };
}

export const reducerWishlistToken: InjectionToken<ActionReducerMap<CustomWishlistState>> = new InjectionToken<ActionReducerMap<CustomWishlistState>>(
  'WishlistReducers',
);

export const reducerWishlistProvider: Provider = {
  provide: reducerWishlistToken,
  useFactory: getWishlistReducers,
};
